<h1 class="mb-2">
  <mdb-icon fas icon="cog"></mdb-icon> Operaciones
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Configuración Usuarios</span>
      <span> /</span>
      <span>Operaciones</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body">
    <div class="row filtros-header justify-content-end" style="border-bottom: 1px solid #dee2e6;">
      <button type="button" mdbBtn color="info" (click)="showNew(); showModalAgregar()" size="sm" mdbWavesEffect>
        Agregar
      </button>
    </div>
    <div class="row filtros-body align-items-center">
      <div class="col" style="max-width: 150px;">
        <div class="md-form mb-0">
          <input value="" type="text" id="boperacion" [(ngModel)]="nombre" class="form-contcategoria"
            placeholder="Operaciones" required #operaciones />
          <label for="Operaciones">Operaciones</label>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
    <div></div>
    <button mdbBtn type="button" color="secondary" (click)="obtenerDatosSegunFiltro(nombre)" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>Buscar
    </button>
  </div>
</div>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Codigo</th>
            <th scope="col">Operación</th>
            <th scope="col">Descripción</th>
            <th scope="col">Fecha de creación</th>
            <th scope="col">Estado</th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!operacionList || operacionList.length === 0">
            <td colspan="6" style="text-align: center;">
              No se encontro informacion
            </td>
          </tr>
          <tr *ngFor="let ope of operacionList">
            <td>{{ ope.codigo }}</td>
            <td>{{ ope.nombre }}</td>
            <td>{{ ope.descripcion }}</td>
            <td>{{ ope.fecha_creacion | date: "dd/MM/yyyy" }}</td>
            <td>
              <div *ngIf="ope.activado">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </div>
              <div *ngIf="!ope.activado">
                <mdb-badge pill="true" warning="true">Inactivo</mdb-badge>
              </div>
            </td>
            <td>
              <button class="btn-actions-sm" color="info" mdbBtn type="button" size="sm" mdbWavesEffect
                data-toggle="modal" data-target="#basicExample" (click)="showForEdit(ope); showModalModificar()"
                mdbTooltip="Editar" placement="right">
                <mdb-icon fas icon="pen"></mdb-icon>
              </button>
              <button *ngIf="ope.activado" class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
                (click)="permitirCambioEstado(ope)" mdbTooltip="Desactivar" placement="right">
                <mdb-icon fas icon="ban"></mdb-icon>
              </button>
              <button *ngIf="!ope.activado" class="btn-actions-sm" color="success" mdbBtn type="button" mdbWavesEffect
                (click)="permitirCambioEstado(ope)" mdbTooltip="Activar" placement="right">
                <mdb-icon fas icon="check"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar Operaciones -->
<div mdbModal #agregarOperaciones="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <!-- Formulario -->
      <form [formGroup]="formulario" (ngSubmit)="insertar(); agregarOperaciones.hide()">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
            (click)="agregarOperaciones.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">Datos de operación</h5>
              </div>
              <div class="col">
                <div class="switch">
                  <label>Inactivo<input type="checkbox" formControlName="activado" checked="" /><span class="lever"></span> Activo</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input formControlName="nombre" value="" type="text" id="enoperacion" class="form-control"
                    placeholder="Nombre" required #noperacion maxlength="25" />
                  <label for="noperacion">Nombre</label>
                  <div *ngIf="formulario.get('nombre').invalid && (formulario.get('nombre').dirty || formulario.get('nombre').touched)">
                    <mdb-error *ngIf="formulario.get('nombre').hasError('required')">El Nombre es requerido.</mdb-error>
                    <mdb-error *ngIf="formulario.get('nombre').hasError('maxlength')">El Nombre no puede superar los 25 caracteres.
                    </mdb-error>
                    <mdb-error *ngIf="formulario.get('nombre').hasError('minlength')">El Nombre debe tener como mínimo 5 caracteres.</mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input formControlName="descripcion" value="" type="text" id="edescripcion" class="form-control" placeholder="Descripción" required #descripcion maxlength="50" />
                  <label for="descripcion">Descripción</label>
                  <div *ngIf="formulario.get('descripcion').invalid && (formulario.get('descripcion').dirty || formulario.get('descripcion').touched)">
                    <mdb-error *ngIf="formulario.get('descripcion').hasError('required')">La Descripcion es requerido.</mdb-error>
                    <mdb-error *ngIf="formulario.get('descripcion').hasError('maxlength')">La Descripcion no puede superar los 50
                      caracteres.</mdb-error>
                    <mdb-error *ngIf="formulario.get('descripcion').hasError('minlength')">La Descripcion debe tener como mínimo 5 caracteres.</mdb-error>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="agregarOperaciones.hide()" mdbWavesEffect>Cerrar</button>
          <button class="btn btn-secondary waves-light" mdbWavesEffect [disabled]="formulario.invalid" type="submit">Guardar</button>
        </div>
      </form>
    </div>
  </div>
</div>


<!-- MODAL Editar Operaciones -->
<div mdbModal #editarOperaciones="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <!-- Formulario -->
      <form [formGroup]="formulario" (ngSubmit)="actualizar(); editarOperaciones.hide()">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="editarOperaciones.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">Datos de operación</h5>
              </div>
              <div class="col">
                <div class="switch">
                  <label>Inactivo<input type="checkbox" formControlName="activado" checked="" /><span class="lever"></span> Activo</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input formControlName="nombre" value="" type="text" id="anoperacion" class="form-control"
                    placeholder="Nombre" required #noperacion maxlength="25" />
                  <label for="noperacion">Nombre</label>
                  <div *ngIf="formulario.get('nombre').invalid && (formulario.get('nombre').dirty || formulario.get('nombre').touched)">
                    <mdb-error *ngIf="formulario.get('nombre').hasError('required')">El Nombre es requerido.</mdb-error>
                    <mdb-error *ngIf="formulario.get('nombre').hasError('maxlength')">El Nombre no puede superar los 25 caracteres.</mdb-error>
                    <mdb-error *ngIf="formulario.get('nombre').hasError('minlength')">El Nombre debe tener como mínimo 5 caracteres.</mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input formControlName="descripcion" value="" type="text" id="adescripcion" class="form-control" placeholder="Descripción" required #descripcion maxlength="50" />
                  <label for="descripcion">Descripción</label>
                  <div *ngIf="formulario.get('descripcion').invalid && (formulario.get('descripcion').dirty || formulario.get('descripcion').touched)">
                    <mdb-error *ngIf="formulario.get('descripcion').hasError('required')">La Descripcion es requerido.</mdb-error>
                    <mdb-error *ngIf="formulario.get('descripcion').hasError('maxlength')">La Descripcion no puede superar los 50 caracteres.</mdb-error>
                    <mdb-error *ngIf="formulario.get('descripcion').hasError('minlength')">La Descripcion debe tener como mínimo 5 caracteres.</mdb-error>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="editarOperaciones.hide()" mdbWavesEffect>Cerrar</button>
          <button class="btn btn-secondary waves-light" mdbWavesEffect [disabled]="formulario.invalid" type="submit">Guardar</button>
        </div>
      </form>
    </div>
  </div>
</div>